const readSubcookie = (cv, sck) =>
  decodeURIComponent((cv.split(/&/).find((sc) => sc.startsWith(`${sck}=`)) || "").slice(sck.length + 1)) || undefined

export default readSubcookie
